export {
    debounce,
    isEqual,
    some,
    each,
    clone,
    cloneDeep,
    defaultsDeep,
} from "lodash";

export const safeJsonParse = (value, fallback = null) => {
    try {
        return JSON.parse(value);
    } catch {
        return fallback;
    }
};
